import { put, call, takeLatest } from 'redux-saga/effects';
import * as appConstants from 'redux/constants/app.constants';
import * as constants from 'redux/constants/systemStatus.constants';
import {
  getSystemStatus,
  updateSystemStatus as updateSystemStatusService,
} from '../../services/systemStatus.services';

export function* initialize(): Generator {
  try {
    const { data }: any = yield call(getSystemStatus);

    yield put({ type: 'GET_SYSTEM_STATUS_SUCCEEDED', data });
  } catch (error) {
    yield put({ type: 'GET_SYSTEM_STATUS_FAILED', error });
  }
}

export function* updateSystemStatus(action: any): Generator {
  try {
    const { formData } = action;
    const { data }: any = yield call(updateSystemStatusService, formData);
    yield put({ type: 'UPDATE_SYSTEM_STATUS_SUCCEEDED', data });
  } catch (error) {
    yield put({ type: 'UPDATE_SYSTEM_STATUS_FAILED', error });
  }
}

export function* watchSystemStatus() {
  yield takeLatest(appConstants.APP_ON_INITIALIZE_REQUESTED, initialize);
  yield takeLatest(constants.UPDATE_SYSTEM_STATUS_REQUESTED, updateSystemStatus);
}
